import {
  ChatSmileOutlineIcon,
  ChevronRightIcon,
  ListItem,
  ListItemContent,
} from '@mr-yum/frontend-ui'
import { useLogger } from 'hooks/useLogger'
import React, { useMemo } from 'react'
import { useIntl } from 'react-intl'

interface Props {
  surveyLink?: string | null
  tabId?: string
  orderId?: string
}

export const SurveyCTA = ({ surveyLink, tabId, orderId }: Props) => {
  const intl = useIntl()
  const loggerProps = useMemo(
    () => ({ defaultProperties: { surveyLink, orderId, tabId } }),
    [surveyLink, orderId, tabId],
  )
  const { logEvent } = useLogger(loggerProps)

  return (
    <ListItem size="lg" asChild isInteractive>
      <a
        className="block"
        href={surveyLink || ''}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() =>
          logEvent('Clicked on rate my experience on order confirmation')
        }
      >
        <ListItemContent
          label={intl.formatMessage({
            defaultMessage: 'Rate your experience',
            id: 'Ut7ZVi',
          })}
          labelWeight="normal"
          size="lg"
          leftIcon={<ChatSmileOutlineIcon />}
          rightIcon={<ChevronRightIcon />}
        />
      </a>
    </ListItem>
  )
}
